import About from "./About";
import Contact from "./Contact";
import Home from "./Home";
import ProjectDetails from "./ProjectDetails";

const compos = { About, Contact, ProjectDetails, Home };

export default compos;
